import { Component, OnInit, Input, SimpleChanges, ViewChild, forwardRef } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { 
    IonGrid, IonRow, IonCol, IonSpinner, IonIcon
} from '@ionic/angular/standalone';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import moment from 'moment';

import { MarvMessageComponent,  MarvSelectItem } from '@marv/components';
import { MarvDateService } from '@marv/services';
import { OperationSelectComponent, RetailerLogoComponent } from '@app/components';
import { OperationService, OrderService } from '@app/services';
import { PlanningSummary } from '@app/models';

@Component({
    selector: 'app-operation-planning-summary',
    templateUrl: './planning-summary.component.html',
    styleUrls: ['./planning-summary.component.scss'],
    imports: [
        IonGrid, IonRow, IonCol, IonSpinner, IonIcon, TranslatePipe, ReactiveFormsModule,
        forwardRef(() => MarvMessageComponent), forwardRef(() => OperationSelectComponent), forwardRef(() => RetailerLogoComponent)
    ]
})
export class OperationPlanningSummaryComponent  implements OnInit {

    @Input({alias : 'typesMissions', required : false}) typesMissions: Array<string> = [];

    @ViewChild('operationSelect') operationSelect: OperationSelectComponent;

    isFetching: boolean = false;
    planningSummary: PlanningSummary|null = null;
    startDatePlanningSummary: string = moment('01-01','MM-DD').format('DD/MM/YYYY');
    endDatePlanningSummary: string = moment('01-12','MM-DD').format('DD/MM/YYYY');
    
    operationForm: FormGroup = new FormGroup({
        operationKey: new FormControl(null)
    });   
    operationSubscription: Subscription;

    constructor(
        public translateService: TranslateService,
        private orderService: OrderService
    ) { }

    ngOnInit() {
        this.operationSubscription = this.operationForm.controls['operationKey'].valueChanges.subscribe(async (newValue) => {
            await this.loadSummary();
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if(changes['typesMissions']){
            
        }
    }
    
    ngOnDestroy() {
        if(this.operationSubscription){
            this.operationSubscription.unsubscribe();
        } 
    }

    async onChangeOperations(operationsItems: Array<MarvSelectItem>){      
        if(operationsItems.length > 0){
            this.operationForm.controls['operationKey'].setValue(operationsItems[0].value, {emitEvent: false});            
        }
        await this.loadSummary();
    }
    
    async loadSummary(){
        
        this.isFetching = true;
        
        let planningSummary: PlanningSummary|null = null;
        let operationKey = this.operationForm.controls['operationKey'].value;
        let startDatePlanningSummary = moment('01-01','MM-DD').toDate();
        let endDatePlanningSummary = moment('01-12','MM-DD').toDate();
                    
        if(operationKey){
            let operationInfos = operationKey.split('|');
            if(operationInfos.length === 2){
                let operation = OperationService.Operations.find(o => o.type == operationInfos[0] && o.id == operationInfos[1]);
                if(operation){
                    if(operation.earliestPlannableDate){
                        let startDate = MarvDateService.ToDate(operation.earliestPlannableDate);
                        if(startDate){
                            startDatePlanningSummary = startDate;
                        }
                    }
                    if(operation.latestPlannableDate){
                        let endDate = MarvDateService.ToDate(operation.latestPlannableDate);
                        if(endDate){
                            endDatePlanningSummary = endDate;
                        }
                    }   
                    planningSummary = await this.orderService.loadPlanningSummary(OperationService.OperationsSettings, operation.id, operation.type, startDatePlanningSummary, endDatePlanningSummary);
                    
                }
            }
        }
                
        this.planningSummary = planningSummary;
        this.startDatePlanningSummary = moment(startDatePlanningSummary).format('DD/MM/YYYY');
        this.endDatePlanningSummary = moment(endDatePlanningSummary).format('DD/MM/YYYY');
        
        this.isFetching = false;
    }
}
